import { render, staticRenderFns } from "./ProspectAlerteCreate.vue?vue&type=template&id=69579188"
import script from "./ProspectAlerteCreate.vue?vue&type=script&lang=ts"
export * from "./ProspectAlerteCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports